import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';



import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

export default function Indust() {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const lang = useSelector(state => state.langReducer.lang);

    const [supBtnHover, setSupBtnHover] = useState(false);

    const partner_top_sample = 6;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    useEffect(() => {

    }, []);
    
    
    return (
        <>
            <div className="main_back">
                <div className="main_part padding">
                    <div className="header_page_title_box">
                        <p className="title">
                            {lang === 0 ? '실시간 유니티 시뮬레이션 환경' : 'Real-time Unity Simulation Environment'}
                        </p>
                        <span className="sub_title">
                            {lang === 0 ? '유니티에서 최종 제품 디자인을 실시간으로 확인하세요.' : 'Check your final product design in real-time within Unity.'}
                        </span>

                        <div className="btn_box">
                            <button
                                type="button"
                                className={`start ${lang === 1 ? 'eng' : ''}`}
                                onClick={() => {
                                    navigate(routes.Price);
                                }}
                            >
                                {lang === 0 ? '14일 무료로 써보기' : 'Try it free for 14 days'}
                            </button>

                            <button
                                type="button"
                                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                                onClick={() => {
                                    navigate(routes.Inquiry);
                                }}
                            >
                                {lang === 0 ? '영업팀과 대화하기' : 'Talk to our sales team'}
                            </button>
                        </div>
                    </div>

                    <div className="header_page_content_box">
                        <div className="content">
                            <div className="img_box">
                                <img src={require("../../assets/icon/header_page_test_img1.svg").default} />
                            </div>

                            <div className="title_box">
                                <div className="top_title">
                                    {lang === 0 ? 
                                        <>
                                            3D 프린팅
                                        </>
                                        : 
                                        <>
                                            3D Printing
                                        </>
                                    }
                                </div>
                                <p>
                                    {lang === 0 ? 
                                        <>
                                            빠른 디자인,<br /><div></div>
                                            빠른 프로토타이핑
                                        </>
                                        : 
                                        <>
                                            Fast Design,<br /><div></div>
                                            Fast Prototyping
                                        </>
                                    }
                                </p>
                                <span>
                                    {lang === 0 ? 
                                        <>
                                            여러분의 디자인을 3D 프린팅을 통해,<br /><div></div>
                                            빠르게 프로토타이핑 해보세요.<br /><div></div>
                                            OBJ, STL, PLY 익스포터를 지원합니다. 
                                        </>
                                        :
                                        <>
                                            Quickly prototype your designs<br /><div></div>
                                            through 3D printing.<br /><div></div>
                                            Supports OBJ, STL, and PLY exporters.
                                        </>
                                    }
                                </span>
                            </div>
                        </div>

                        <div className="content end">
                            <div className="title_box">
                                <div className="top_title">
                                    {lang === 0 ? 
                                        <>
                                            디지털 트윈
                                        </>
                                        : 
                                        <>
                                            Digital Twin
                                        </>
                                    }
                                </div>
                                <p>
                                    {lang === 0 ? 
                                        <>
                                            실감나는<br /><div></div>
                                            리얼타임 시뮬레이션
                                        </>
                                        : 
                                        <>
                                            Immersive<br /><div></div>
                                            Real-time Simulation
                                        </>
                                    }
                                </p>
                                <span>
                                    {lang === 0 ? 
                                        <>
                                            실시간 데이터를 활용해<br /><div></div>
                                            환경 동작을 시뮬레이션하고 분석하며,<br /><div></div>
                                            프로세스를 최적화하고 리소스 낭비를 줄이세요.
                                        </> 
                                        : 
                                        <>
                                            Simulate and analyze environmental behavior<br /><div></div>
                                            using real-time data, optimize processes,<br /><div></div>
                                            and reduce resource waste.
                                        </>
                                    }
                                </span>
                            </div>

                            <div className="img_box">
                                <img src={require("../../assets/icon/header_page_test_img2.svg").default} />
                            </div>
                        </div>

                        <div className="content">
                            <div className="img_box">
                                <img src={require("../../assets/icon/header_page_test_img3.svg").default} />
                            </div>

                            <div className="title_box">
                                <div className="top_title">
                                    {lang === 0 ? 
                                        <>
                                            디테일
                                        </>
                                        : 
                                        <>
                                            Detail
                                        </>
                                    }
                                </div>
                                <p>
                                    {lang === 0 ? 
                                        <>
                                            정밀하고 고급스러운<br /><div></div>
                                            고품질 3D 모델링
                                        </>
                                        : 
                                        <>
                                            Precise and Sophisticated<br /><div></div>
                                            High-Quality 3D Modeling
                                        </>
                                    }
                                </p>
                                <span>
                                    {lang === 0 ? 
                                        <>
                                            놀라울 정도로 사실적이고 정밀한 모델링으로<br /><div></div>
                                            실물 제작 전에 실제와 같은 디테일을 확인하세요.
                                        </>
                                        :
                                        <>
                                            With incredibly realistic and precise modeling,<br /><div></div>
                                            check lifelike details before physical production.
                                        </>
                                    }
                                </span>
                            </div>
                        </div>

                        <div className="content end">
                            <div className="title_box">
                                <div className="top_title">
                                    {lang === 0 ? 
                                        <>
                                            Pixyz
                                        </>
                                        : 
                                        <>
                                            Pixyz
                                        </>
                                    }
                                </div>
                                <p>
                                    {lang === 0 ? 
                                        <>
                                            최고의 CAD 데이터 최적화<br /><div></div>
                                            소프트웨어와 함께
                                        </>
                                        : 
                                        <>
                                            Optimize CAD Data with<br /><div></div>
                                            the Best Software
                                        </>
                                    }
                                </p>
                                <span>
                                    {lang === 0 ? 
                                        <>
                                            최고의 CAD 데이터 준비 및 최적화 소프트웨어,<br /><div></div>
                                            Pixyz로 가져온 데이터를 유니티에서 바로 편집해보세요.
                                        </> 
                                        : 
                                        <>
                                            Use Pixyz, the best CAD data preparation<br /><div></div>
                                            and optimization software, to edit your data in Unity.
                                        </>
                                    }
                                </span>
                            </div>

                            <div className="img_box">
                                <img src={require("../../assets/icon/header_page_test_img4.svg").default} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="main_part" style={{ background: '#FAFAFA'}}>
                    <div className="title_box partner" style={{ marginBottom: '60px' }}>
                        {lang === 0 ? '투자사 및 파트너' : 'Investors and Partners'}
                    </div>

                    <div className="video_slide_container partner">
                        <div className="video_slide_track partner">
                            {[...Array(partner_top_sample)].map((x, i) => (
                                <div className="video_slide_item partner" key={i}>
                                    <img src={images?.[`logo${i + 1}`]} alt={`slide-${i}`} />
                                </div>
                            ))}
                        </div>

                        <div className="video_slide_track partner sub">
                            {[...Array(partner_top_sample)].map((x, i) => (
                                <div className="video_slide_item partner" key={i}>
                                    <img src={images?.[`logo${i + 7}`]} alt={`slide-${i}`} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="page_start_banner">
                    <div className="content">
                        <p className="title">
                            {lang === 0 ? 
                                <>
                                    유니티를 산업디자인에 100% 활용하고 싶다면
                                </>
                                :
                                <>
                                    If you want to make the most of<br />
                                    Unity in industrial design
                                </>
                            }
                        </p>

                        <div className="btn_box">
                            <button
                                type="button"
                                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                                onClick={() => {
                                    navigate(routes.Inquiry);
                                }}
                            >
                                {lang === 0 ? '영업팀에 문의' : 'Contact Sales'}
                            </button>

                            <button
                                type="button"
                                className={`start ${lang === 1 ? 'eng' : ''}`}
                                onClick={() => {
                                    navigate(routes.Price);
                                }}
                            >
                                {lang === 0 ? '무료로 써보기' : 'Try Free'}
                            </button>
                        </div>
                    </div>
                </div>
                
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
